// Set VITE_APP_FONT_URL to the approved HTTPS font file or packaged /static/fonts/*.ttf.
// A missing file must not block rendering; do not claim a system fallback is the design font.
export function loadAppFont() {
  const url = import.meta.env.VITE_APP_FONT_URL || ''
  if (!url || typeof uni.loadFontFace !== 'function') return
  uni.loadFontFace({
    global: true,
    family: 'ZenMuse Sans',
    source: `url("${url.replace(/["\\]/g, '')}")`,
    fail: () => console.warn('Design font unavailable; using system fallback')
  })
}
